import {useEffect, useState} from "react";
import {Header} from "./_containers/header/Header";
import "./App.sass"
import HomePage from "./pages/common/anonymous/HomePage";
import LoginPage from "./pages/common/anonymous/LoginPage";
import {Route, Routes, useLocation} from "react-router";
import Courses from "./pages/common/anonymous/courses/Courses";
import Teachers from "./pages/common/anonymous/Teachers";
import PrivateRoute from "./_components/PrivateRoute";
import MainStudentPage from "./pages/student/MainStudentPage";
import {useDispatch, useSelector} from "react-redux";
import {ROLE_ADMIN, ROLE_STUDENT, ROLE_TEACHER} from "./common/roles";
import MainTeacherPage from "./pages/teacher/MainTeacherPage";
import ScheduleTeacherPage from "./pages/teacher/ScheduleTeacherPage";
import CoursePage from "./pages/common/anonymous/courses/CoursePage";
import RequestPage from "./pages/common/anonymous/courses/RequestPage";
import AboutPage from "./pages/common/anonymous/about/AboutPage";
import RequestsAdminPage from "./pages/admin/request/RequestsAdminPage";
import TeacherPage from "./pages/common/anonymous/TeacherPage";
import GroupPage from "./pages/teacher/group/GroupPage";
import logo from "./images/logo_white.png";
import _ from "lodash";
import Spinner from "./pages/common/anonymous/Spinner";
import HomeworkEditorPage from "./pages/teacher/homework/HomeworkEditorPage";
import AddStudentPage from "./pages/teacher/AddStudentPage";
import HomeworkStudentPage from "./pages/student/homework/HomeworkStudentPage";
import CommonHomeworkEditorPage from "./pages/common/authenticated/CommonHomeworkEditorPage";
import GamePage from "./pages/common/authenticated/game/GamePage";
import MentalTrainingPage from "./pages/common/authenticated/training/MentalTrainingPage";
import BalancePage from "./pages/student/balance/BalancePage";
import MainAdminPage from "./pages/admin/MainAdminPage";
import AddTeacherPage from "./pages/admin/teacher/AddTeacherPage";
import {isAuthenticated} from "./_actions/auth/authService";
import PayPage from "./pages/teacher/PayPage";
import {FAILED, IDLE, LOADING, SUCCESS} from "./common/statuses";
import {getInfo, getNotifications} from "./_actions/notification/notificationService";
import TeacherAdminPage from "./pages/admin/teacher/TeacherAdminPage";
import GameRouter from "./pages/game/GameRouter";
import StudentAdminPage from "./pages/admin/student/StudentAdminPage";
import {useSnackbar} from "notistack";
import AbacusPage from "./pages/game/abacus/AbacusPage";
import TrainersPage from "./pages/common/authenticated/TrainersPage";
import PersonalSettings from "./pages/common/authenticated/personalsettings/PersonalSettings";
import NotificationPanel from "./_components/common/notification/NotificationPanel";
import {UniqueVisitorChart} from "./pages/admin/statistic/UniqueVisitorChart";
import {StatisticPage} from "./pages/admin/statistic/StatisticPage";
import {UniqueHostsChart} from "./pages/admin/statistic/UniqueHostsChart";
import {NotFound} from "./pages/NotFound";
import {
    ABACUS_PAGE, ABOUT,
    ADD_STUDENT_PAGE,
    ADD_TEACHER_PAGE,
    BALANCE_PAGE, COLLABORATION_PAGE, COLLABORATION_REQUEST_ADMIN_PAGE, COLLABORATION_REQUEST_PAGE,
    COMMON_HOMEWORK_EDITOR_PAGE, COURSE, COURSES,
    GAME,
    GAME_ROUTER,
    GROUP_PAGE,
    HOME,
    HOME_EDITOR_PAGE,
    HOME_EDITOR_PAGE_BY_STUDENT,
    HOMEWORK_STUDENT_PAGE, LOGIN, MAIN,
    MENTAL_TRAINING_PAGE,
    NOT_FOUND,
    PAY_PAGE,
    PERSONAL_SETTINGS, RECOVERY_PASSWORD, REQUEST_ADMIN_PAGE, REQUEST_PAGE,
    SCHEDULE_TEACHER_PAGE, STATISTIC_PAGE,
    STUDENT_ADMIN_PAGE,
    STUDENT_COMMON_HOMEWORK_EDITOR_PAGE,
    TEACHER_ADMIN_PAGE, TEACHER_PAGE, TEACHERS,
    TRAINERS_PAGE, UNIQUE_HOSTS_CHART, UNIQUE_VISITOR_CHART
} from "./common/links";
import {CollaborationPage} from "./pages/common/anonymous/collaboration/CollaborationPage";
import {CollaborationRequestPage} from "./pages/common/anonymous/collaboration/CollaborationRequestPage";
import {CollaborationRequestsAdminPage} from "./pages/admin/request/CollaborationRequestsAdminPage";
import {RecoveryPassword} from "./pages/common/anonymous/recoverypasswowrd/RecoveryPassword";

export default function App() {

    const [isScrollable, setScrollable] = useState(false);
    const [background, setBackground] = useState({})
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);
    const [intervalId, setIntervalId] = useState(null);

    const {status, current} = useSelector(state => state.auth);
    const {data: notificationInfo, status: notificationInfoStatus} = useSelector(state => state.notification.getInfo);
    const {data: notifications} = useSelector(state => state.notification.getNotifications);

    const dispatch = useDispatch();
    const location = useLocation();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        setScrollable(hasScrollbar && hasScrollbar());
    }, [useSelector(state => state)])
    useEffect(() => {
        let pathname = location.pathname;
        if (pathname === '/') {
            setBackground({})
        } else {
            if (_.isEmpty(background)) {
                setBackground({background: 'rgba(249, 251, 198, 0.4'})
            }
        }
    }, [location.pathname]);
    useEffect(() => {
        if (status === IDLE) {
            dispatch(isAuthenticated())
        }
        if (status === SUCCESS && current) {
            if (current.role !== ROLE_ADMIN)
                dispatch(getInfo())
        }
        if (status === FAILED) {
            clearInterval(intervalId)
            setIntervalId(null)
        }
    }, [current, status, dispatch]);
    useEffect(() => {
        if (notificationInfoStatus === SUCCESS) {
            const {paymentCount} = notificationInfo;
            if (parseInt(paymentCount) > 0) {
                enqueueSnackbar("У вас есть непровереные платёжные документы", {variant: "info"})
            }
        }
    }, [notificationInfoStatus])
    useEffect(() => {
        if (status === SUCCESS) {
            dispatch(getNotifications())
            if (!intervalId) {
                const interval = setInterval(() => {
                    dispatch(getNotifications())
                }, 10000);
                setIntervalId(interval)
            }
        }
    }, [status])

    const hasScrollbar = () => {
        const appWrapper = document.getElementById("app-wrapper");
        if (appWrapper === null || appWrapper.offsetWidth === null || appWrapper.clientWidth === null) {
            return false
        }
        return appWrapper.offsetWidth > appWrapper.clientWidth;
    }

    if (status === LOADING || status === IDLE) {
        if (/\/home.*/gm.test(location.pathname)) {
            return <Spinner/>
        }
    }

    const getCountNotifications = () => {
        if (notifications) {
            return notifications.filter(n => n.status === "SENT").length
        } else {
            return 0
        }
    }

    const renderMainPage = () => {
        if (current.role === ROLE_STUDENT) {
            return <MainStudentPage/>
        }
        if (current.role === ROLE_TEACHER) {
            return <MainTeacherPage/>
        }
        if (current.role === ROLE_ADMIN) {
            return <MainAdminPage/>
        }
    }

    const roleForAnonymous = (Page) => {
        return <PrivateRoute roles={[ROLE_TEACHER, ROLE_STUDENT, ROLE_ADMIN]}>
            <Page/>
        </PrivateRoute>

    }

    const anonymousRoutes = () => {
        return <>
            <Route index path={LOGIN} element={<LoginPage/>}/>
            {/*<Route index path={MAIN} element={roleForAnonymous(HomePage)}/>*/}
            <Route index path={MAIN} element={roleForAnonymous(HomePage)}/>

            <Route index path={COURSES} element={roleForAnonymous(Courses)}/>
            <Route index path={COURSE} element={roleForAnonymous(CoursePage)}/>
            <Route index path={REQUEST_PAGE} element={roleForAnonymous(RequestPage)}/>

            <Route index path={TEACHERS} element={roleForAnonymous(Teachers)}/>
            <Route index path={TEACHER_PAGE} element={roleForAnonymous(TeacherPage)}/>

            <Route index path={COLLABORATION_PAGE} element={roleForAnonymous(CollaborationPage)}/>
            <Route index path={COLLABORATION_REQUEST_PAGE} element={roleForAnonymous(CollaborationRequestPage)}/>

            <Route index path={ABOUT} element={roleForAnonymous(AboutPage)}/>

            <Route index path={RECOVERY_PASSWORD} element={<RecoveryPassword/>}/>
        </>
    }

    const teacherRoutes = () => {
        return <>
            <Route index path={PAY_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_TEACHER]}>
                           <PayPage/>
                       </PrivateRoute>}/>
            <Route index path={SCHEDULE_TEACHER_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_TEACHER]}>
                           <ScheduleTeacherPage/>
                       </PrivateRoute>}/>
            <Route index path={GROUP_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_TEACHER]}>
                           <GroupPage/>
                       </PrivateRoute>}/>
            <Route index path={HOME_EDITOR_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_TEACHER]}>
                           <HomeworkEditorPage/>
                       </PrivateRoute>}/>
            <Route index path={HOME_EDITOR_PAGE_BY_STUDENT}
                   element={
                       <PrivateRoute roles={[ROLE_TEACHER]}>
                           <HomeworkEditorPage/>
                       </PrivateRoute>}/>
            <Route index path={ADD_STUDENT_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_TEACHER]}>
                           <AddStudentPage/>
                       </PrivateRoute>}/>
        </>
    }

    const studentRoutes = () => {
        return <>
            <Route index path={HOMEWORK_STUDENT_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_STUDENT]}>
                           <HomeworkStudentPage/>
                       </PrivateRoute>}/>
            <Route index path={STUDENT_COMMON_HOMEWORK_EDITOR_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_STUDENT]}>
                           <CommonHomeworkEditorPage/>
                       </PrivateRoute>}/>
            <Route index path={BALANCE_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_STUDENT]}>
                           <BalancePage/>
                       </PrivateRoute>}/>
        </>
    }

    const adminRoutes = () => {
        return <>
            <Route index path={TEACHER_ADMIN_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <TeacherAdminPage/>
                       </PrivateRoute>}/>
            <Route index path={ADD_TEACHER_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <AddTeacherPage/>
                       </PrivateRoute>}/>
            <Route index path={STUDENT_ADMIN_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <StudentAdminPage/>
                       </PrivateRoute>}/>
            <Route index path={REQUEST_ADMIN_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <RequestsAdminPage/>
                       </PrivateRoute>}/>
            <Route index path={COLLABORATION_REQUEST_ADMIN_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <CollaborationRequestsAdminPage/>
                       </PrivateRoute>}/>


            <Route index path={STATISTIC_PAGE}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <StatisticPage/>
                       </PrivateRoute>}/>
            <Route index path={UNIQUE_VISITOR_CHART}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <UniqueVisitorChart/>
                       </PrivateRoute>}/>
            <Route index path={UNIQUE_HOSTS_CHART}
                   element={
                       <PrivateRoute roles={[ROLE_ADMIN]}>
                           <UniqueHostsChart/>
                       </PrivateRoute>}/>
        </>
    }

    return (
        <>
            <div id="app-wrapper" className="app-wrapper">
                <Header onNotificationClick={() => setShowNotificationPanel(!showNotificationPanel)}
                        countNotifications={getCountNotifications()}/>
                <div className="footer-wrapper"
                     style={background}>
                    <div className="footer-content">
                        <Routes>
                            {anonymousRoutes()}

                            <Route index path={HOME}
                                   element={
                                       <PrivateRoute>
                                           {current && renderMainPage()}
                                       </PrivateRoute>}/>

                            <Route index path={GAME}
                                   element={
                                       <PrivateRoute roles={[ROLE_TEACHER, ROLE_STUDENT]}>
                                           <GamePage/>
                                       </PrivateRoute>}/>
                            <Route index path={PERSONAL_SETTINGS}
                                   element={
                                       <PrivateRoute roles={[ROLE_TEACHER, ROLE_STUDENT, ROLE_ADMIN]}>
                                           <PersonalSettings/>
                                       </PrivateRoute>}/>

                            <Route index path={TRAINERS_PAGE}
                                   element={
                                       <PrivateRoute roles={[ROLE_TEACHER, ROLE_STUDENT]}>
                                           <TrainersPage/>
                                       </PrivateRoute>}/>

                            <Route index path={MENTAL_TRAINING_PAGE}
                                   element={
                                       <PrivateRoute roles={[ROLE_TEACHER, ROLE_STUDENT]}>
                                           <MentalTrainingPage/>
                                       </PrivateRoute>}/>
                            <Route index path={COMMON_HOMEWORK_EDITOR_PAGE}
                                   element={
                                       <PrivateRoute roles={[ROLE_TEACHER, ROLE_STUDENT]}>
                                           <CommonHomeworkEditorPage/>
                                       </PrivateRoute>}/>
                            <Route index path={ABACUS_PAGE}
                                   element={
                                       <PrivateRoute roles={[ROLE_TEACHER, ROLE_STUDENT]}>
                                           <AbacusPage/>
                                       </PrivateRoute>}/>

                            {teacherRoutes()}
                            {studentRoutes()}
                            {adminRoutes()}

                            <Route path={GAME_ROUTER} element={<GameRouter/>}/>
                            <Route path={NOT_FOUND} element={<NotFound/>}/>
                        </Routes>
                    </div>
                </div>
            </div>
            <div style={!isScrollable ? {width: '100%'} : {}} className="grass">
                <div className="grass-name"><img src={logo} alt="QI Center"/></div>
            </div>
            <NotificationPanel show={showNotificationPanel}
                               onHide={() => setShowNotificationPanel(false)}/>
        </>
    );
}
